module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_6.faffc04b.png";